import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
// import { useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import DrawerComponent from './Drawer';
import { Outlet } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import { useTheme } from '@mui/material/styles';
import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined';
// redux
import { useSelector, useDispatch } from 'react-redux';

import { isRepManager } from '@util/helper';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import ClassOutlinedIcon from '@mui/icons-material/ClassOutlined';
import WorkHistoryOutlinedIcon from '@mui/icons-material/WorkHistoryOutlined';
import UpcomingOutlinedIcon from '@mui/icons-material/UpcomingOutlined';
import EventRepeatOutlinedIcon from '@mui/icons-material/EventRepeatOutlined';
import CastForEducationOutlinedIcon from '@mui/icons-material/CastForEducationOutlined';
import CoPresentOutlinedIcon from '@mui/icons-material/CoPresentOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import HailOutlinedIcon from '@mui/icons-material/HailOutlined';
import AnnouncementOutlinedIcon from '@mui/icons-material/AnnouncementOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import ChairAltOutlinedIcon from '@mui/icons-material/ChairAltOutlined';
// import logo from '@images/logo-tns.png'
import logo from '@images/logo_white.png'
import Avatar from '@mui/material/Avatar';
import useStyles from '@hooks/useStyles'
import CommonDrawer from '@components/CommonDrawer'
import TextsmsOutlinedIcon from '@mui/icons-material/TextsmsOutlined';
import GridOnOutlined  from '@mui/icons-material/GridOnOutlined';
import SavingsOutlined  from '@mui/icons-material/SavingsOutlined';
import PollOutlined from "@mui/icons-material/PollOutlined";

const mainColor = '#33c058'
const drawerWidth = 240;

export default function ManagerDrawer() {
  const classes = useStyles();
  const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isMobile = false
  
  // redux
  const codeGroups = useSelector(state => state.codeGroupReducer)
  const codes = useSelector(state => state.codeReducer)
  const schools = useSelector(state => state.schoolReducer)
  const account = useSelector(state => state.accountReducer)
  const schola = useSelector(state => state.scholaReducer)

  const [activeMenu, set_activeMenu] = React.useState({})
  const [activeIdx, set_activeIdx] = React.useState(1)

  const defIcon = <LabelOutlinedIcon size='small' sx={{color:'#212121'}}/>
  const defSx = {color:'#212121', fontSize:20}
  const primaryTypographyProps = (index) => {
    return {
      style: {
        fontSize:14, 
        fontFamily: ['JejuGothic', 'sans-serif'],
        color: activeIdx === index ? theme.palette.primary.main : '#212121',
        fontWeight:activeIdx === index ? 'bold' : 'normal'
      }

    }
  }
  const sideMenu = [
    // {text:'Test',     to:'/scm/test'},
    {text:'divider', visible: true},
    {text:'수강현황',   to:'/manager/dashboard', visible: true, icon:<GridOnOutlined size='small' sx={defSx}/> },
    {text:'일정',   to:'/manager/schedule', visible: true, icon:<CalendarMonthOutlinedIcon size='small' sx={defSx}/> },
    {text:'divider', visible: true},

    {text:'학생',      to:'/manager/student', visible: true, icon:<ClassOutlinedIcon size='small' sx={defSx}/> },
    {text:'매니저',   to:'/manager/manager', visible: true, icon:<ManageAccountsOutlinedIcon size='small' sx={defSx}/>},
    {text:'강사',   to:'/manager/user/S003', visible: true, icon:<CoPresentOutlinedIcon size='small' sx={defSx}/> },
    {text:'보호자',    to:'/manager/user/S002', visible: false},
    {text:'divider', visible: true},

    {text:'학기',     to:'/manager/smst' , visible: true, icon:<EventRepeatOutlinedIcon size='small' sx={defSx}/> },
    {text:'강좌',     to:'/manager/lecture', visible: true, icon:<CastForEducationOutlinedIcon size='small' sx={defSx}/>},
    {text:'수강신청',   to:'/manager/regi' , visible: true, icon:<HailOutlinedIcon size='small' sx={defSx}/>},
    {text:'스쿨뱅킹',   to:'/manager/bill' , visible: true, icon:<SavingsOutlined size='small' sx={defSx}/>},
    {text:'출석현황',     to:'/manager/attdnc', visible: true, icon:<ChairAltOutlinedIcon size='small' sx={defSx}/>},
    {text:'divider', visible: true},

    {text:'공지사항',   to:'/manager/notice' , visible: true, icon:<AnnouncementOutlinedIcon size='small' sx={defSx}/>},
    // {text:'설문조사',   to:'/manager/survey' , visible: true, icon:<PollOutlined size='small' sx={defSx}/>},
    {text:'divider', visible: true},

    {text:'푸시 메시지',     to:'/manager/message', visible: true, icon:<SendOutlinedIcon size='small' sx={defSx}/>},
    {text:'문자 메시지',     to:'/manager/message/sms', visible: true, icon:<TextsmsOutlinedIcon size='small' sx={defSx}/>},
    {text:'divider', visible: true},
    // {text:'설문조사',     to:'/scm/attdnc'},
  ]

  
  return (
    <CommonDrawer sideMenu={sideMenu} title={schola.name} />
  );
}
